// extracted by mini-css-extract-plugin
export default {"wrapper":"FaqSimple_wrapper__XUUYA","title":"FaqSimple_title__KXYnZ","item":"FaqSimple_item__OKH6f"};